import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { AppGlobal } from '../../Shared/global';
import { CommonService } from '../../Shared/common.service';
// import { EncrDecrService } from '../../Shared/encr-decr.service';

@Component({
  selector: 'app-dashboard',
  templateUrl: 'login.component.html',
})
export class LoginComponent {

  loginForm: FormGroup;
  submitted = false;
  isAuthenticate = false;
  isvisible = false;

  constructor(private router: Router, private fb: FormBuilder, private commonService: CommonService) {
    this.loginForm = this.fb.group({
      username: ['', [Validators.required]],
      password: ['', [Validators.required]]
    });
  }

  get f() {
    return this.loginForm.controls;
  }

  login() {
    this.submitted = true;
    const data = {
      username: this.loginForm.value.username,
      password: this.loginForm.value.password
    };

    const url = AppGlobal.getApiUrl(`AdminUser/login`);
    this.commonService.post(url, data).subscribe(
      (response) => {
        if (response.status === 200) {
          
          if(localStorage.getItem('info') !== null){
            localStorage.removeItem('info');
          }
          localStorage.setItem('info', JSON.stringify(response.data));
          this.router.navigateByUrl('/admin-user');
          this.submitted = false;
          this.isAuthenticate = false;
          this.loginForm.reset();
        }

        if (response.status === 401) {
          this.isAuthenticate = true;
        }
      });
  }

  isVisiblePass(){
    this.isvisible = !this.isvisible;
  }

}
